import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';

const WaterReadingForm = ({
  reading,
  saving,
  onChange,
  onSave,
  errors,
  systemState,
}) => {
  return (
    <Form>
      <FormGroup className="mr-4 mb-md-2">
        <Label for="masterMeter" className="mr-2">
          Master Meter
        </Label>
        <Input
          type="number"
          id="masterReading"
          name="masterReading"
          value={reading.masterReading}
          onChange={onChange}
        />
        {errors.masterReading && (
          <Alert className="mt-2 p-2" color={'danger'}>
            {errors.masterReading}
          </Alert>
        )}
      </FormGroup>
      <FormGroup className="mr-4 mb-md-2">
        <Label for="freeChlorine" className="mr-2">
          Chlorine Free
        </Label>
        <Input
          type="number"
          id="freeChlorine"
          value={reading.freeChlorine}
          onChange={onChange}
        />
        {errors.freeChlorine && (
          <Alert className="mt-2 p-2" color={'danger'}>
            {errors.freeChlorine}
          </Alert>
        )}
      </FormGroup>
      {systemState === 'MO' && (
        <FormGroup className="mr-4 mb-md-2">
          <Label for="totalChlorine" className="mr-2">
            Chlorine Total
          </Label>
          <Input
            type="number"
            id="totalChlorine"
            value={reading.totalChlorine}
            onChange={onChange}
          />
          {errors.totalChlorine && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.totalChlorine}
            </Alert>
          )}
        </FormGroup>
      )}
      {systemState === 'AR' && (
        <FormGroup className="mr-4 mb-md-2">
          <Label for="chemicalReading" className="mr-2">
            Chemicals Added
          </Label>
          <Input
            type="number"
            id="chemicalReading"
            value={reading.chemicalReading}
            onChange={onChange}
          />
          {errors.chemicalReading && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.chemicalReading}
            </Alert>
          )}
        </FormGroup>
      )}
      <FormGroup className="mr-4 mb-md-2">
        <Label for="comments" className="mr-2">
          Comments
        </Label>
        <Input
          type="textarea"
          id="comments"
          value={reading.comments}
          onChange={onChange}
        />
        {errors.comments && (
          <Alert className="mt-2 p-2" color={'danger'}>
            {errors.comments}
          </Alert>
        )}
      </FormGroup>
      <FormGroup className="text-center mt-4">
        <Button color="primary" type="submit" onClick={onSave}>
          {saving ? 'Saving' : 'Save'}
        </Button>
      </FormGroup>
    </Form>
  );
};

WaterReadingForm.propTypes = {
  reading: PropTypes.object.isRequired,
};

export default WaterReadingForm;



// WEBPACK FOOTER //
// ./src/components/reading/water/WaterReadingForm.js